export default "__VITE_ASSET__DGnAC2wA__"